/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimeFont = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <rect width="16" height="16" rx="2" fill="#DADBE0"></rect>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.33867 4.71207C8.28268 4.5833 8.15563 4.5 8.01521 4.5C7.87479 4.5 7.74774 4.5833 7.69175 4.71207L5.17241 10.5066C5.09474 10.6852 5.17659 10.893 5.35523 10.9707C5.53387 11.0483 5.74165 10.9665 5.81932 10.7878L6.71297 8.73245L9.31745 8.73245L10.2111 10.7878C10.2888 10.9665 10.4965 11.0483 10.6752 10.9707C10.8538 10.893 10.9357 10.6852 10.858 10.5066L8.33867 4.71207ZM9.01075 8.02703L8.01521 5.7373L7.01967 8.02703H9.01075Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            d="M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V21.5C24 22.8807 22.8807 24 21.5 24H2.5C1.11929 24 0 22.8807 0 21.5V2.5Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.47384 7.39691C9.39546 7.21662 9.21759 7.10001 9.021 7.10001C8.82441 7.10001 8.64655 7.21662 8.56816 7.39691L5.04108 15.5092C4.93234 15.7593 5.04693 16.0502 5.29703 16.1589C5.54713 16.2677 5.83802 16.1531 5.94676 15.903L7.19786 13.0254L10.8441 13.0254L12.0952 15.903C12.204 16.1531 12.4949 16.2677 12.745 16.1589C12.9951 16.0502 13.1097 15.7593 13.0009 15.5092L9.47384 7.39691ZM10.4148 12.0379L9.021 8.83222L7.62725 12.0379H10.4148ZM17.9038 13.5898C17.9038 14.4079 17.2406 15.0712 16.4225 15.0712C15.6043 15.0712 14.9411 14.4079 14.9411 13.5898C14.9411 12.7717 15.6043 12.1084 16.4225 12.1084C17.2406 12.1084 17.9038 12.7717 17.9038 13.5898ZM16.4225 11.1208C16.9783 11.1208 17.4912 11.3045 17.9038 11.6145C17.9039 11.3418 18.125 11.1208 18.3976 11.1208C18.6704 11.1208 18.8914 11.3419 18.8914 11.6146V13.5898V15.565C18.8914 15.8377 18.6704 16.0588 18.3976 16.0588C18.125 16.0588 17.9039 15.8378 17.9038 15.5652C17.4912 15.8751 16.9783 16.0588 16.4225 16.0588C15.0589 16.0588 13.9535 14.9534 13.9535 13.5898C13.9535 12.2262 15.0589 11.1208 16.4225 11.1208Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            d="M3.39001 7.82499C3.39001 4.03079 6.46582 0.954987 10.26 0.954987H27.9481C29.7183 0.954987 31.4202 1.63832 32.6989 2.8625L42.4909 12.2368C43.8445 13.5327 44.61 15.3254 44.61 17.1993V42.175C44.61 45.9692 41.5342 49.045 37.74 49.045H10.26C6.46582 49.045 3.39001 45.9692 3.39001 42.175V7.82499Z"
                            fill="#DADBE0"
                        ></path>
                        <path
                            d="M44.4742 15.84H35.45C32.2881 15.84 29.725 13.2768 29.725 10.115V1.18875C30.8322 1.48525 31.8572 2.05671 32.6989 2.86249L42.4908 12.2368C43.5121 13.2146 44.1987 14.4751 44.4742 15.84Z"
                            fill="#EBECF0"
                        ></path>
                        <path
                            d="M44.6099 17.5575H35.4499C31.3396 17.5575 28.0074 14.2254 28.0074 10.115V0.955231C28.5921 0.960284 29.1689 1.03984 29.7249 1.18874V10.115C29.7249 13.2768 32.2881 15.84 35.4499 15.84H44.4742C44.5638 16.2841 44.6099 16.7393 44.6099 17.1993V17.5575Z"
                            fill="#BABBC5"
                        ></path>
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M20.3912 23.4241C20.2792 23.1666 20.0251 23 19.7443 23C19.4634 23 19.2094 23.1666 19.0974 23.4241L14.0587 35.0131C13.9033 35.3704 14.067 35.786 14.4243 35.9413C14.7816 36.0967 15.1972 35.933 15.3525 35.5757L17.1398 31.4649L22.3488 31.4649L24.1361 35.5757C24.2914 35.933 24.707 36.0967 25.0642 35.9413C25.4215 35.786 25.5852 35.3704 25.4299 35.0131L20.3912 23.4241ZM21.7354 30.0541L19.7443 25.4746L17.7532 30.0541H21.7354ZM32.4341 32.2711C32.4341 33.4399 31.4866 34.3874 30.3178 34.3874C29.149 34.3874 28.2016 33.4399 28.2016 32.2711C28.2016 31.1024 29.149 30.1549 30.3178 30.1549C31.4866 30.1549 32.4341 31.1024 32.4341 32.2711ZM30.3178 28.7441C31.1118 28.7441 31.8446 29.0064 32.4341 29.4492C32.4342 29.0597 32.75 28.7441 33.1395 28.7441C33.5291 28.7441 33.8449 29.0599 33.8449 29.4495V32.2711V35.0928C33.8449 35.4824 33.5291 35.7982 33.1395 35.7982C32.75 35.7982 32.4342 35.4825 32.4341 35.0931C31.8446 35.5358 31.1118 35.7982 30.3178 35.7982C28.3699 35.7982 26.7907 34.2191 26.7907 32.2711C26.7907 30.3232 28.3699 28.7441 30.3178 28.7441Z"
                            fill="#3A3F4A"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
